<template>

	<g ref="radio" class="radio">
		<path fill="#D6CED1" d="M520.1,30.4c-1.2-4.6-5.9-7.3-10.5-6L105,132.8l2.2,16.8c0.7,0,1.5-0.1,2.2-0.3L514,40.8
	C518.6,39.6,521.3,34.9,520.1,30.4z"/>
		<g class="radio--border">
			<path fill="#C2B8B9" d="M107.2,132.5c-12.9,0-23.3,10.4-23.3,23.3v34.4h46.5v-34.4C130.5,142.9,120,132.5,107.2,132.5z"/>
			<path fill="#463836" d="M538.2,167.4c12.5,0,22.8,10.2,22.8,22.8v296c0,12.5-10.2,22.8-22.8,22.8H71.8c-12.5,0-22.8-10.2-22.8-22.8
				v-296c0-12.5,10.2-22.8,22.8-22.8H538.2z"/>
		</g>
		<circle fill="#ECE7EA" cx="200.3" cy="338.2" r="104.7"/>
		<g>
			<circle fill="#8B7E7F" cx="377.7" cy="354.4" r="26.2"/>
			<circle fill="#8B7E7F" cx="488.3" cy="354.4" r="26.2"/>
		</g>
		<rect x="351.5" y="211.9" fill="#FFFFFF" width="162.9" height="81.5"/>
		<g>
			<polygon fill="#8B7E7F" points="351.5,415.5 351.5,462.4 405.8,462.4 417.2,439 405.8,415.5 	"/>
			<polygon fill="#8B7E7F" points="514.5,415.5 460.1,415.5 448.8,439 460.1,462.4 514.5,462.4 	"/>
		</g>
		<rect x="405.8" y="415.5" fill="#C2B8B9" width="54.3" height="46.9"/>
		<path fill="#F14742" d="M398.1,240.3c-4.7,0-8.5,3.8-8.5,8.5v44.5h17.1v-44.5C406.6,244.1,402.8,240.3,398.1,240.3z"/>
		<g id="dynamic">
			<path fill="#8B7E7F" d="M200.3,408c-38.5,0-69.8-31.3-69.8-69.8s31.3-69.8,69.8-69.8s69.8,31.3,69.8,69.8S238.8,408,200.3,408z"/>
			<path fill="#605353" d="M200.3,381.6c-4.7,0-8.5-3.8-8.5-8.5v-69.8c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v69.8
		C208.8,377.8,205,381.6,200.3,381.6z"/>
			<path fill="#605353" d="M165.4,372.2c-4.7,0-8.5-3.8-8.5-8.5v-51.1c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5v51.1
		C173.9,368.4,170.1,372.2,165.4,372.2z"/>
			<path fill="#605353" d="M235.2,372.2c-4.7,0-8.5-3.8-8.5-8.5v-51.1c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v51.1
		C243.7,368.4,239.9,372.2,235.2,372.2z"/>
		</g>
	</g>

</template>

<script>
	import { TimelineMax } from 'gsap'

	export default {
		name: "IconRadio",
		data: function () {
			return {
				tl:undefined,
			}
		},
		mounted() {
			this.tl = new TimelineMax({repeat:-1});
		},
		methods: {
			play() {
				this.tl.to('#dynamic', 0.5, {scale:1.25, transformOrigin:"center"});
				this.tl.to('#dynamic', 0.5, {scale:1, transformOrigin:"center"});
			},
			stop() {
				this.tl.kill();
			}
		}
	}
</script>

<style>

	.radio:hover .radio--border {
		stroke: yellow;
		stroke-width: 25;
	}


</style>
